import React from "react";
import { useNavigate } from "react-router-dom";
import chocalas from "../../assets/chocalas.jpg";
import Button from "../Button";

const Hero1 = ({ imageSrc }) => {
    const navigate = useNavigate();

    return (
        <div className="flex bg-[#0346a4] text-white p-6 items-center justify-between z-2 relative px-40">
            <div className="max-w-2xl">
                <h2 className="text-5xl font-bold">Finanzas abiertas</h2>
                <p className="text-5xl mt-2 text-[#e8f2f4] font-bold mt-12" style={{ textShadow: '2px 2px 10px rgba(0,0,0,0.3)' }}>
                    Haz todo desde un mismo lugar, compara, adquiere y centraliza tu información.
                </p>
                <div className="mt-12 pr-10">
                    <Button onClick={() => navigate("/politica-datos")} text="Conoce nuestra Política de Tratamiento de Datos Personales" fullWidth="true" color="bg-[#276ae8]" textColor="text-white" paddingY="py-2" paddingX="px-6" rounded="rounded-full" border="border-transparent" textSize="font-bold" disableHover={false} />
                </div>

            </div>
            <img src={chocalas} alt="Finanzas abiertas" className="rounded-3xl my-10  w-[40%] h-96 object-cover" />

        </div>
    );
};

export default Hero1;
